import { render, staticRenderFns } from "./depositProject.vue?vue&type=template&id=d008bb1e"
import script from "./depositProject.vue?vue&type=script&lang=js"
export * from "./depositProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports